import { useState } from "react";
import { contactoServices } from "../../../../services/contacto.services";
import "./certificado-etica.scss";

export default function CertificadoEtica() {
  const [nombre, setNombre] = useState("");
  const [tipoDoc, setTipoDoc] = useState("");
  const [numDoc, setNumDoc] = useState("");
  const [numMatricula, setNumMatricula] = useState("");
  const [fecMatriculacion, setFecMatriculacion] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError("");
    contactoServices
      .send({
        recipient: "cofolp@gmail.com",
        subject: "Solicitud de Certificado de Ética",
        body:
          `<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden;">` +
          `<div style="background: #1e293b; padding: 24px 32px;">` +
          `<h2 style="color: white; margin: 0; font-size: 1.2rem;">Solicitud de Certificado de Ética</h2>` +
          `<p style="color: #94a3b8; margin: 4px 0 0 0; font-size: 0.85rem;">Colegio de Fonoaudiólogos de La Pampa</p>` +
          `</div>` +
          `<div style="padding: 32px;">` +
          `<table style="width: 100%; border-collapse: collapse;">` +
          `<tr><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #64748b; width: 45%; font-size: 0.9rem;">Nombre y Apellido</td><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #1e293b; font-weight: 600;">${nombre}</td></tr>` +
          `<tr><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #64748b; font-size: 0.9rem;">Tipo de Documento</td><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #1e293b; font-weight: 600;">${tipoDoc}</td></tr>` +
          `<tr><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #64748b; font-size: 0.9rem;">Número de Documento</td><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #1e293b; font-weight: 600;">${numDoc}</td></tr>` +
          `<tr><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #64748b; font-size: 0.9rem;">Número de Matrícula</td><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #1e293b; font-weight: 600;">${numMatricula}</td></tr>` +
          `<tr><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #64748b; font-size: 0.9rem;">Fecha de Matriculación</td><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #1e293b; font-weight: 600;">${fecMatriculacion}</td></tr>` +
          `<tr><td style="padding: 10px 0; color: #64748b; font-size: 0.9rem;">Email de contacto</td><td style="padding: 10px 0; color: #1e293b; font-weight: 600;">${email}</td></tr>` +
          `</table>` +
          `</div>` +
          `<div style="background: #f8fafc; padding: 16px 32px; font-size: 0.8rem; color: #94a3b8; text-align: center;">` +
          `Este mensaje fue generado automáticamente desde el portal de COFOLP.` +
          `</div>` +
          `</div>`,
      })
      .then(() => {
        setSuccess(true);
        setNombre("");
        setTipoDoc("");
        setNumDoc("");
        setNumMatricula("");
        setFecMatriculacion("");
        setEmail("");
      })
      .catch(() =>
        setError("No se pudo enviar la solicitud. Intente nuevamente.")
      )
      .finally(() => setLoading(false));
  };

  return (
    <section id="etica" className="section certificado-etica-page">
      <div className="container section-title fade-up">
        <h2>Solicitud de Certificado de Ética</h2>
        <p>
          Complete el siguiente formulario para realizar la solicitud al
          Colegio. Nos comunicaremos con usted a la brevedad.
        </p>
      </div>

      <div className="container fade-up mt-4">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="row gy-4">
                <div className="col-md-12">
                  <label className="form-label text-muted small mb-1">
                    Nombre y Apellido
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label text-muted small mb-1">
                    Tipo de Documento
                  </label>
                  <select
                    className="form-select"
                    value={tipoDoc}
                    onChange={(e) => setTipoDoc(e.target.value)}
                    required
                  >
                    <option value="">Seleccione...</option>
                    <option value="DNI">DNI</option>
                    <option value="LE">LE</option>
                    <option value="LC">LC</option>
                  </select>
                </div>

                <div className="col-md-8">
                  <label className="form-label text-muted small mb-1">
                    Número de Documento
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={numDoc}
                    onChange={(e) => setNumDoc(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label text-muted small mb-1">
                    Número de Matrícula Profesional
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={numMatricula}
                    onChange={(e) => setNumMatricula(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label text-muted small mb-1">
                    Fecha de Matriculación
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={fecMatriculacion}
                    onChange={(e) => setFecMatriculacion(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label text-muted small mb-1">
                    Email de contacto
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-12 text-center">
                  {loading && <div className="loading">Enviando...</div>}
                  {error && <div className="error-message">{error}</div>}
                  {success && (
                    <div className="sent-message">
                      Su solicitud ha sido enviada. ¡Gracias!
                    </div>
                  )}
                  <button type="submit" disabled={loading}>
                    {loading ? "Enviando..." : "Enviar Solicitud"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
